import { Component, Input, OnInit } from "@angular/core";
import { PreferenceService } from "../../../shared/services/preference.service";
import { Preference } from "../../../shared/models/preference";
import { DepartmentService } from "../../../shared/services/department.service";
import { Department } from "../../../shared/models/department";
import { Router } from "@angular/router";
import { SearchService } from "../../../shared/services/search.service";

@Component({
  selector: "app-slider",
  templateUrl: "./slider.component.html",
  styleUrls: ["./slider.component.scss"],
  providers: [PreferenceService],
})
export class SliderComponent implements OnInit {
  urlBanners: String[];
  urlBannersMobile: String[];
  url: string;
  @Input() preferences: Preference[];
  departments: Department[] = [];
  @Input() selectedDepartmentId: number;

  constructor(
    private departmentService: DepartmentService,
    private route: Router,
    private searchService: SearchService
  ) {
    this.urlBanners = [];
  }

  ngOnInit() {
    this.load();
  }

  load = () => {
    const banners = this.preferences.find((el) => el.value === "bannerImg");
    const bannerMobile = this.preferences.find(
      (el) => el.value === "bannerImgMobile"
    );
    this.urlBanners = banners ? banners.value2.split(/\|/) : [];
    this.urlBannersMobile = bannerMobile ? bannerMobile.value2.split(/\|/) : [];
    this.departmentService.getDepartments().subscribe((res) => {
      this.departments = this.departmentService.getDepartmentByResponse(res);
    });
  };

  goToDepartment(id: number) {
    this.searchService.vaciarProductoABuscar();
    if (id) {
      this.route.navigate(["/articlesDepartment", id]);
    } else {
      this.route.navigate(["/"]);
    }
  }
}
